export function getPathWithParams(
	path: string,
	params: Record<string, string | number>,
) {
	return Object.keys(params).reduce(
		(res, k) => res.replace(`:${k}`, `${params[k]}`),
		path,
	);
}
